import React, {createContext, useEffect, useMemo, useRef, memo, useCallback} from "react"
import './auction-lots-listing.css';
import MainLotView from "./components/main-lots-view";

import useLotListFn from "./useLotListFn";
import LotsListItem from "./components/lots-list-item/lots-list-item";

const LotsContext = createContext();
export {LotsContext};

const AuctionLotsListing = memo(() => {
    const lotListData = useLotListFn();
    const {lotsData = [], phrases: {you_have_no_auctions, no_lots_sold_or_hidden}, type} = lotListData;
    const containerRef = useRef(null);

    // Мемоизированный список лотов - рендерим напрямую без дополнительного состояния
    const lotList = useMemo(() => {
        if (!lotsData || lotsData.length === 0) {
            return <div key={'no_lots'}>{type === 'sale' ? no_lots_sold_or_hidden : you_have_no_auctions}</div>
        }
        return lotsData.map((lotData) => (
            <LotsListItem 
                key={type === 'all_user_bets' ? lotData.bid_id : lotData.auction_id}
                lotData={lotData}
            />
        ));
    }, [lotsData, type, no_lots_sold_or_hidden, you_have_no_auctions]);

    // Разделяем контекст на статичные и динамичные части
    const staticContextValue = useMemo(() => ({
        promotion_color: lotListData.promotion_color,
        show_img_lots_list: lotListData.show_img_lots_list,
        auction_categories: lotListData.auction_categories,
        phrases: lotListData.phrases,
        visitor: lotListData.visitor,
        user_id: lotListData.user_id,
        type: lotListData.type,
        year: lotListData.year,
        user_lots_type: lotListData.user_lots_type,
        time_wait_take: lotListData.time_wait_take,
        time_wait_send: lotListData.time_wait_send,
        time_wait_pay: lotListData.time_wait_pay,
    }), [
        lotListData.promotion_color, lotListData.show_img_lots_list, 
        lotListData.auction_categories, lotListData.phrases, 
        lotListData.visitor, lotListData.user_id, lotListData.type, 
        lotListData.year, lotListData.user_lots_type, 
        lotListData.time_wait_take, lotListData.time_wait_send, 
        lotListData.time_wait_pay
    ]);

    const dynamicContextValue = useMemo(() => ({
        changeLots: lotListData.changeLots
    }), [lotListData.changeLots]);

    const contextValue = useMemo(() => ({
        ...staticContextValue,
        ...dynamicContextValue
    }), [staticContextValue, dynamicContextValue]);

    const activateXenForo = useCallback(() => {
        if (containerRef.current && window.XenForo && typeof window.XenForo.activate === 'function') {
            window.XenForo.activate(document);
        }
    }, []);

    useEffect(() => {
        activateXenForo();
    }, [activateXenForo, lotsData]);

    return (
        <MainLotView ref={containerRef}>
            <LotsContext.Provider value={contextValue}>
                {lotList}
            </LotsContext.Provider>
        </MainLotView>
    );
});

export default AuctionLotsListing;
